{
  "ρυθμίσεις": "Ρυθμίσεις",
  "yourDigitalAssistant": "Ο ψηφιακός σας βοηθός",
  "getStarted": "Ξεκινήστε",
  "login": "Login",
  "loggingIn": "Σύνδεση ...",
  "darkMode": "Dark mode",
  "clearHistory": "Εκκαθάριση ιστορικού",
  "historyCleared": "Το ιστορικό διαγράφηκε",
  "changeLanguage": "Γλώσσα",
  "termsAndConditions": "Όροι Χρήσης",
  "messagePlaceholder": "Πληκτρολογήστε το μήνυμά σας εδώ ...",
  "messagePlaceholderDisabled": "Η πληκτρολόγηση απενεργοποιήθηκε ...",
  "feedbackTitle": "Αξιολογήστε την εμπειρία σας",
  "feedbackPlaceholder": "Πείτε μας για αυτό (προαιρετικό)",
  "feedbackSend": "Αποστολή",
  "feedbackClose": "Κλείσιμο",
  "sessionExpired": "Η συνεδρία σας έληξε λόγω αδράνειας.",
  "startNewSession": "Ξεκινήστε μια νέα συνεδρία",
  "apiError": "Ωχ! Κάτι πήγε στραβά. Εργαζόμαστε για να το διορθώσουμε το συντομότερο δυνατό.",
  "apiErrorOffline": "Δεν είστε συνδεδεμένοι στο Διαδίκτυο.",
  "tryAgain": "Δοκιμάστε ξανά",
  "startOver": "Ξεκινήστε ξανά",
  "chatEnded": "Η συζήτηση έληξε.",
  "chatEndedThankYou": "Σας ευχαριστούμε που συνομιλήσατε μαζί μας!",
  "closeChat": "Κλείσε",
  "startNewChat": "Συζητήστε ξανά",
  "humanTakeoverStarted": "Τώρα μεταφέρεστε στην εξυπηρέτηση πελατών ...",
  "humanTakeoverQueued": "Περιμένοντας να συνδεθώ με έναν πράκτορα",
  "humanTakeoverAnAgent": "Ένας πράκτορας",
  "humanTakeoverAgentEntered": "μπήκε στη συνομιλία",
  "humanTakeoverAgentLogout": "άφησε τη συνομιλία",
  "humanTakeoverTransfer": "Μεταφέρεται σε νέο πράκτορα",
  "humanTakeoverEnded": "Τώρα συνομιλείτε με τον ψηφιακό σας βοηθό",
  "version": "Έκδοση",
  "formIntroText": "Συμπληρώστε την παρακάτω φόρμα για να ξεκινήσετε τη συνομιλία μαζί μας.",
  "formFirstName": "Όνομα",
  "formLastName": "Επώνυμο",
  "formName": "Όνομα",
  "formEmail": "E-mail",
  "formWrongEmail": "Καταχωρίστε μια έγκυρη διεύθυνση ηλεκτρονικού ταχυδρομείου.",
  "formPhone": "Τηλέφωνο",
  "formShipmentId": "Αναγνωριστικό αποστολής",
  "formQuestion": "Η ερώτησή σας",
  "formAccountNumber": "Αριθμός λογαριασμού (για επαγγελματίες πελάτες)",
  "formAddress": "διεύθυνση",
  "formPostcode": "ΤΑΧΥΔΡΟΜΙΚΟΣ ΚΩΔΙΚΟΣ",
  "formCity": "πόλη",
  "formCountry": "Χώρα",
  "formSubmitButton": "Έναρξη συνομιλίας",
  "formEmptyFieldError": "Δεν επιτρέπεται να είναι κενό.",
  "formPhoneNumberValidationError": "Δεν είναι έγκυρος αριθμός τηλεφώνου.",
  "formInputIsBiggerThan50": "Πρέπει να είναι το πολύ 50 χαρακτήρες.",
  "formInputIsBiggerThan100": "Πρέπει να είναι το πολύ 100 χαρακτήρες.",
  "formInputIsBiggerThan2000": "Πρέπει να είναι το πολύ 2000 χαρακτήρες.",
  "widgetEventOnline": "Μήνυμα DA: Ο χρήστης επανήλθε στο διαδίκτυο.",
  "widgetEventHidden": "Μήνυμα DA: Το widget είναι κρυφό.",
  "widgetEventVisible": "Μήνυμα DA: Το widget είναι ορατό.",
  "widgetEventVisibleMinimized": "Μήνυμα DA: Το widget είναι ορατό, αλλά ελαχιστοποιημένο.",
  "widgetEventMinimized": "Μήνυμα DA: Το Widget ελαχιστοποιείται.",
  "widgetEventMaximized": "Μήνυμα DA: Το Widget μεγιστοποιείται.",
  "widgetEventSessionExpired": "Μήνυμα DA: Η περίοδος λειτουργίας Widget έληξε.",
  "widgetEventHangupHuman": "Μήνυμα DA: Ο χρήστης τελειώνει τη συνεδρία εξαγοράς ανθρώπου.",
  "widgetEventUserTyping": "Μήνυμα DA: ο χρήστης πληκτρολογεί.",
  "fileTooLarge": "Προσπαθείτε να επισυνάψετε υπερβολικά μεγάλα αρχεία.",
  "tooManyDiles": "Προσπαθείτε να επισυνάψετε πάρα πολλά αρχεία.",
  "fileInvalidType": "Προσπαθείτε να επισυνάψετε μη έγκυρους τύπους αρχείων.",
  "attachmentsDropHere": "Μεταβείτε εδώ για μεταφόρτωση ή",
  "attachmentsBrowse": "ΕΞΕΡΕΥΝΗΣΗ ΑΡΧΕΙΩΝ",
  "attachmentsExtenstionQuantity": "pdf ή εικόνες (έως 10 αρχεία)",
  "attachmentsSize": "έως 30 MB",
  "attachmentsFailedUploading": "Η μεταφόρτωση απέτυχε",
  "attachmentsUploading": "Μεταφόρτωση ...",
  "minimizeExpandText": "Ζωντανή συνομιλία μαζί μας τώρα!",
  "popupWidgetNotificationMessage": "Λάβατε νέο μήνυμα!",
  "tabWidgetNotificationMessage": "Νέο μήνυμα!",
  "datepickerSendButton": "στείλετε"
}
